<div class={$$props.class}>
  <slot></slot>
</div>
